const VERSION = process.env.REACT_APP_PULSE_VERSION;

export { VERSION };
